export default __webpack_public_path__ + "static/media/ant-design_instagram-filled.7610f378.svg";